import { useEffect, useState } from "react";

import PbxServerStatusCard from "./PbxServerStatusCard";
import errorResolver from "../../../utils/error-resolver";
import { useProtectedAxiosInstance } from "../../../hooks/axiosInstance";
import { useNotificationContext } from "../../../context/notificationContext";
import { FilterOperatorEnum } from "../../../services/Schemas/ListQueryString";
import {
  PbxServerListColumnFilterable,
  PbxServerResponseBody,
  PbxServersListRequest,
} from "../../../services/Endpoints/pbxserver/PbxServerListEndpoint";

import { Grid, Stack, Typography } from "@mui/material";

interface PartnerStatusCardWrapperProps {
  refreshKey?: number;
  forceReload?: boolean;
  refreshInterval?: number;
}

export default function PbxServerStatusCardWrapper({
  refreshInterval = 0,
  forceReload,
  refreshKey,
}: PartnerStatusCardWrapperProps) {
  const protectedInstance = useProtectedAxiosInstance();
  const { setNotification } = useNotificationContext();

  const [pbxServers, setPbxServers] = useState<PbxServerResponseBody | null>(
    null,
  );
  const [waiting, setWaiting] = useState(false);

  const getData = async () => {
    try {
      setWaiting(true);
      const pbxServersListRequest = new PbxServersListRequest(protectedInstance);
      const resp = await pbxServersListRequest.list({
        filters: [
          {
            column: PbxServerListColumnFilterable.STATUS,
            operator: FilterOperatorEnum.EQUAL,
            value: "online",
          },
        ],
      });
      setPbxServers(resp);
      setWaiting(false);
    } catch (error) {
      errorResolver({ error, setNotification });
      setWaiting(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Stack>
      <Typography variant="h6" mb={1}>
        لیست سرور های مرکزی فعال ({pbxServers?.data.pbx_servers.length})
      </Typography>
      {waiting ? (
        <Stack>در حال دریافت سرور های مرکزی ... </Stack>
      ) : (
        <>
          {pbxServers?.data.pbx_servers.length === 0 ? (
            <Stack> هیج سرور مرکزی یافت نشد</Stack>
          ) : (
            <Grid container spacing={2}>
              {pbxServers?.data.pbx_servers.map((pbx_server) => (
                <Grid item key={pbx_server.id} xs={12} lg={6}>
                  <PbxServerStatusCard
                    partner={pbx_server}
                    forceReload={forceReload}
                    refreshInterval={refreshInterval}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </>
      )}
    </Stack>
  );
}
